import _ from 'underscore';
import { BaseCacheManager } from './base-cache-manager';

/**
 * @typedef {Object} ClientCacheKey
 * @property {string} resource - Resource name (entity type name)
 * @property {string} adapter - Adapter name
 * @property {Object} query - The query object
 */

export class ClientCacheManager extends BaseCacheManager {
  /**
   * Client side cache manager to cache the response data
   * @param {Object} options -
   * @param {MatchStrategy[]} matchStrategies - The match strategies
   * @param {PartitionStrategy[]} partitionStrategies - The partition strategies
   */
  constructor({
    matchStrategies,
    partitionStrategies,
  }) {
    super();

    // Initialize the match strategies
    this.matchStrategies = matchStrategies;
    _.each(this.matchStrategies, strategy => strategy.initializeCacheManager(this));

    // Initialize the partition strategy
    this.partitionStrategies = partitionStrategies;
    _.each(this.partitionStrategies, strategy => strategy.initializeCacheManager(this));

    // Delegate the notifications from all storage caches, so that the cacheIndex
    // can be updated accordingly
    _.each(this.partitionStrategies, ({ cache }) => cache && cache.subscribe(this));
  }

  /**
   * Get the storage cache (TimeAwareCache) according to the partition strategy
   * @override
   * @param {ClientCacheKey} key - The cache key
   * @returns {TimeAwareCache} - The storage cache for the given key
   */
  storageCacheFor(key) {
    return _.chain(this.partitionStrategies)
      .find(strategy => strategy.condition(this, key))
      .result('cache', null)
      .value();
  }

  /**
   * Find the cached result using the matching strategies
   * @param {ClientCacheKey} key - The cache key
   * @returns {*} - The matched value
   */
  match(key) {
    let result = null;

    _.find(this.matchStrategies, (strategy) => {
      result = strategy.match(this, key);
      return Boolean(result);
    });

    return result;
  }
}
